// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apparatus-wrapper[data-v-3cf6ff06] {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  border-radius: 0.25rem;\n  padding: 0.75em;\n  margin-bottom: 0.5em;\n}\n.statusText[data-v-3cf6ff06] {\n  display: inline;\n  text-transform: capitalize;\n}\n.collapsed > .when-open[data-v-3cf6ff06],\n.not-collapsed > .when-closed[data-v-3cf6ff06] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
